<template>
  <v-layout row justify-center>
    <v-dialog
      v-model="dialog"
      persistent
      width="300"
    >
      <v-card
        color="accent"
        dark
      >
        <v-card-text>
          {{ content }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
export default {
  props: [
    'content',
    'dialog',
  ],
  watch: {
    dialog (val) {
      if (!val) return;
    }
  }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/popup/LoadingDialog.vue